export interface FormlyButtonDropdown {
  split: boolean;
  items: FormlyButtonDropdownItem[];
}

export interface FormlyButtonDropdownItem {
  text: string;
  iconClass?: string;
  onClick?: () => void;
  select?: (model: any) => void;
}
